module.exports = __webpack_public_path__ + "img/wisdom_icon2.5bc10106.png";